import { Injectable } from '@angular/core';
import { ReasonsModel } from './model/reasons.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ReasonsService {

  constructor(private http: HttpClient) { }

  getReasonsList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/reasons/get', requestData);

  }

  getContextList(): Observable<any> {
    return this.http.post(environment.baseUrl+'/reasons/context','');

  }

  getReasonsById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/reasons/get/'+id, '');

  }

   /**
   * 
   * @param reasonsInfo 
   * Calls the update API to insert/update the record
   */
   update(reasonsInfo: ReasonsModel): Observable<any> { 
    if(reasonsInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/reasons/update', reasonsInfo);
    } else{
      return this.http.post(environment.baseUrl+'/reasons/add', reasonsInfo);
    }
  }


    /**
   * 
   * @param reasonsInfo 
   * Calls the API to delete the record
   */
    delete(reasonsInfo: ReasonsModel): Observable<any>  {
      return this.http.post(environment.baseUrl+'/reasons/delete/'+reasonsInfo.id, reasonsInfo);
    }

    downloadExcel(requestData: any): Observable<Blob> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.http.post(environment.baseUrl + '/reasons/export', requestData, { headers, responseType: 'blob' })
        .pipe(
          //catchError(this.handleError)
        );
  
    }

}
